<template>
    <div class="resume-item-module personal-module">
        <h1 class="module-title">个人信息</h1>
        <thumbnail :width="110" :gender="data.gender === 1 ? 'man': 'woman'" class="mt-20"></thumbnail>
        <personal ref="personal" :init="data"></personal>
    </div>
</template>
<script type="text/javascript">
    import Personal from './items/personal'
    import Thumbnail from 'components/thumbnail'

    export default {
        props: {
            data: Object
        },
        data () {
            return {}
        },
        components: {
            Personal,
            Thumbnail
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";
</style>


// WEBPACK FOOTER //
// personalModule.vue?e5b8535e